import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { accountService, billService } from "../../_services";
import Currency from "react-currency-formatter";
import { filter } from "rxjs/operators";
import { ResetPassword } from "../../account/ResetPassword";
import config from "../../_helpers/config";

import { MultiVendor } from "./MultiVendor";
import { Members } from "./Members";
import { Roles } from "./Roles";
import { Franchise } from "./Franchise";
import "./View.css";
import Invoice from "./Invoice";
import ManageSubscription from "./ManageSubscription";
import AddRolePermissionPopup from "./AddRolePermissionPopup";
import ExpiryPopup from "./ExpiryPopup";
import { toast } from "../../_components/Toast";
function View({ history, match }) {
  const { id } = match.params;
  const [user, setUser] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalComponent, setModalComponent] = useState(null);
  const [isDeactivated, setIsDeactivated] = useState(
    user && user.status === "deactive"
  );
  const [showConfirm, setShowConfirm] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [invoiceTitle, setInvoiceTitle] = useState("");
  const [invoiceComponent, setInvoiceComponent] = useState(null);
  const [plans, setPlans] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showExpiryPopup, setShowExpiryPopup] = useState(false);

  let loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const MemberIdCheck = (id) => /^[a-f0-9]{24}$/i.test(id);

  const [bill, setBill] = useState({
    purchaseItems: [
      {
        price_data: {
          currency: "INR",
          unit_amount: 0,
          product_data: {
            name: "",
            description: "",
          },
        },
        quantity: 1,
      },
    ],
  });

  const [isSubmitting, setSubmitting] = useState(false);

  /// Edited By rabindra
  const [billData, setBillData] = useState();
  const [editBill, setEditBill] = useState(false);
  const [createBill, setCreateBill] = useState(false);
  const [createBillData, setCreateBillData] = useState({
    payStatus: "paid",
    purchaseItems: [
      {
        price_data: {
          currency: "INR",
          unit_amount: 0,
          product_data: {
            name: "",
            description: "",
          },
        },
        quantity: 1,
      },
    ],
  });
  const [checkBox, setCheckBox] = useState("payed");
  const [role, setRole] = useState({});
  const [editUserDetails, setEditUserDetails] = useState();
  const token = sessionStorage.getItem("jwtToken") || sessionStorage.getItem("jwtDLAuth") || sessionStorage.getItem("userData").token; // all location taken

  useEffect(() => {
    axios
      .get(`${config.AUTH_API_SERVER}/plan`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setPlans(res.data || []);
      })
      .catch((err) => {
        console.error("Error fetching plans:", err);
        setPlans([]);
      });


    axios.get(
      `${config.AUTH_API_SERVER}/subscriptions/subscriptions/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ).then(res => {
      console.log(res.data);
      setSubscriptions(res.data || [])
    }).catch(error => {
      console.error("Error fetching subscriptions:", error);
      setSubscriptions([]);
    })


  }, [])

  useEffect(() => {
    // get user and set form fields
    accountService.getById(id).then((user) => {
      // console.log(user);
      billService.getUserBill(user.id).then((bills) => {
        if (bills && bills.length) {
          bills[0].purchaseItems = JSON.parse(bills[0].purchaseItems);
          setBill(bills[0]);
        }
      });
      setUser(user);
      setIsDeactivated(user && user.status === "deactive");

      billService.getUserBills(id).then((bills) => {
        if (bills && bills.length) {
          setBillData(bills);
          // console.log(bills);
        }
      });

      if (user && user.validUntil && loggedInUser) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of day

        const expiryDate = new Date(user.validUntil);
        expiryDate.setHours(0, 0, 0, 0); // Reset time to start of day

        const timeDiff = expiryDate.getTime() - today.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        console.log('View.jsx expiry check:', {
          user: user.firstName + ' ' + user.lastName,
          validUntil: user.validUntil,
          today: today.toISOString(),
          expiryDate: expiryDate.toISOString(),
          daysDiff,
          shouldShow: daysDiff <= 4,
          planId: user.planId,
          loggedInUserRole: loggedInUser && loggedInUser.role
        });

        // Show popup only if plan expires in 4 days or less (including expired plans)
        if (daysDiff <= 4) {
          console.log('Setting showExpiryPopup to true');
          setShowExpiryPopup(true);
        }
      } else {
        console.log('Expiry check skipped:', {
          hasUser: !!user,
          hasValidUntil: !!(user && user.validUntil),
          hasPlanId: !!(user && user.planId),
          isSuperAdmin: !!(loggedInUser)
        });
      }

      // console.log("user");
      // console.log(billData);
    });
  }, [id, isSubmitting]);

  useEffect(() => {
    const subscription = accountService.user.subscribe((x) => setRole(x));
    return () => subscription.unsubscribe();
  }, []);


  //const token = sessionStorage.getItem("jwtToken");
  const getSubsPlanById = (planId) => {
    if (!planId || !plans.length) {
      return <span className="plan-chip plan-no-plan">
        No Plan
      </span>;
    }

    // Find the subscription with matching _id
    const sub = subscriptions.find(s => s._id === planId);
    if (!sub) {
      return <span className="plan-chip plan-unknown">
        Unknown Plan
      </span>;
    }

    // Find the associated plan and attach it
    const pl = plans.find(p => p.id === sub.planId);
    if (pl) {
      return <span className={`plan-chip`}>{`${pl.planName}, ${sub.frequency},  ${sub.currency} ${sub.frequencyPrice}`}</span>;
    }

  };
  // Helper function to get plan name from plan ID
  const getPlanNameById = (planId) => {
    console.log(planId);
    if (!planId || !plans.length) {
      return "No Plan";
    }

    // Find the subscription with matching _id
    const sub = subscriptions.find(s => s._id === planId);
    if (!sub) {
      return "No Plan";
    }

    // Find the associated plan and attach it
    const pl = plans.find(p => p.id === sub.planId);
    if (pl) {
      return `${pl.planName}, ${sub.frequency}, ${sub.frequencyPrice}`;
    }

  };


  const updateBill = (e, property) => {
    let newBill = bill;
    newBill[property] = e.target.value;
    setBill(newBill);
  };

  const updateBillProduct = (e, field) => {
    let newBill = bill;
    newBill["purchaseItems"][0]["price_data"]["product_data"][field] =
      e.target.value;
    setBill(newBill);
  };

  const createBillProduct = (e, field) => {
    let newBill = createBillData;
    newBill["purchaseItems"][0]["price_data"]["product_data"][field] =
      e.target.value;
    setCreateBillData(newBill);
  };

  const updateBillPrice = (e, field) => {
    let newBill = bill;
    newBill["purchaseItems"][0]["price_data"][field] = e.target.value;
    setBill(newBill);
  };

  const createBillPrice = (e, field) => {
    let newBill = createBillData;
    newBill["purchaseItems"][0]["price_data"][field] = e.target.value;
    setCreateBillData(newBill);
  };

  const updateBillPayStatus = (e, field) => {
    let newBill = bill;
    newBill[field] = e.target.value;
    setBill(newBill);
  };

  const createBillPayStatus = (e, field) => {
    let newBill = createBillData;
    // console.log(e.target.value);
    newBill[field] = e.target.value;
    setCreateBillData(newBill);
  };

  function onBillingInfoUpdate(id) {
    setSubmitting(true);
    let billSummary = {};
    billSummary.purchaseItems = [
      {
        price_data: {
          currency: bill.purchaseItems[0].price_data.currency,
          unit_amount: bill.purchaseItems[0].price_data.unit_amount.toString(),
          product_data: {
            name: bill.purchaseItems[0].price_data.product_data.name,
            description:
              bill.purchaseItems[0].price_data.product_data.description,
          },
        },
        quantity: 1,
      },
    ];
    billSummary.customer_email = user.email;
    billSummary.success_url = config.CURRENT_UI;
    billSummary.cancel_url = config.CURRENT_UI;
    billSummary.userId = user.id;
    billSummary.appName = "Signage-CMS";
    billSummary.stripeCustomer = "";
    billSummary.payType = "onetime";
    billSummary.payStatus = bill.payStatus; //TODO: make a state to mark payed on unpaid
    billSummary.invoicePath = "";
    billSummary.receiptPath = "";

    billService
      .updateBill(id, billSummary)
      .then((data) => {
        // console.log(data);
        toast.success("Bill Updated Successfully", {
          keepAfterRouteChange: true,
        });
        setSubmitting(false); // submit animation stoped
        setEditBill(false); // Edit form is closing
        // history.push('.');
      })
      .catch((error) => {
        setSubmitting(false);
        toast.error(error);
      });
  }

  const handleToggleAccountStatus = () => {
    const newStatus = isDeactivated ? "active" : "deactive";
    const updatedUser = { ...user, status: newStatus };

    accountService
      .update(user.id, updatedUser)
      .then(() => {
        setUser(updatedUser);
        setIsDeactivated(newStatus === "deactive");
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleConfirm = () => {
    setShowConfirm(false); // Close the modal
    handleToggleAccountStatus(); // Proceed with status update
  };

  const handleDelete = () => {
    setIsDeleting(true);
    accountService.delete(user.id)
      .then(() => {
        toast.success("User deleted successfully");
        history.push('..');
      })
      .catch(error => {
        setIsDeleting(false);
        setShowDeleteDialog(false);
        toast.error(error);
      });
  };

  const handleExpiryExtend = () => {
    // Close expiry popup and open subscription management
    setShowExpiryPopup(false);
    setModalOpen(true);
    setModalTitle("Update Subscription");
    setModalComponent(
      <ManageSubscription
        user={user}
        plans={plans}
        subs={subscriptions}
        closeModal={() => setModalOpen(false)}
        onUpdate={(planId, validUntil) => {
          if (planId && loggedInUser && loggedInUser.role.toUpperCase() == "SUPER-ADMIN") {
            accountService.patch(user.id, { planId, validUntil: validUntil })
              .then(() => {
                setUser(prev => ({ ...prev, planId, validUntil }));
                setModalOpen(false);
                toast.success("Subscription extended successfully");
              })
              .catch(error => toast.error(error));
          } else {
            setModalOpen(false);
            toast.error("Plz contact service provider!!");
          }
        }}
      />
    );
  };

  const handleExpiryClose = () => {
    setShowExpiryPopup(false);
  };

  function onCreateBill() {
    setSubmitting(true);
    let billSummary = {};
    billSummary.purchaseItems = [
      {
        price_data: {
          currency: createBillData.purchaseItems[0].price_data.currency,
          unit_amount:
            createBillData.purchaseItems[0].price_data.unit_amount.toString(),
          product_data: {
            name: createBillData.purchaseItems[0].price_data.product_data.name,
            description:
              createBillData.purchaseItems[0].price_data.product_data
                .description,
          },
        },
        quantity: 1,
      },
    ];
    billSummary.customer_email = user.email;
    billSummary.success_url = config.CURRENT_UI;
    billSummary.cancel_url = config.CURRENT_UI;
    billSummary.userId = user.id;
    billSummary.appName = "Signage-CMS";
    billSummary.stripeCustomer = "";
    billSummary.payType = "onetime";
    billSummary.payStatus = createBillData.payStatus;
    billSummary.invoicePath = "";
    billSummary.receiptPath = "";

    // console.log(billSummary);
    billService
      .createBill(billSummary)
      .then((data) => {
        // console.log(data);
        toast.success("Bill Created Successfully", {
          keepAfterRouteChange: true,
        });
        setSubmitting(false); // submit animation stoped
        setCreateBill(false); // Edit form is closing
        // history.push('.');
      })
      .catch((error) => {
        setSubmitting(false);
        setCreateBill(false);
        toast.error(error);
      });
  }

  function convertDateFormate(dateString) {
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    const dateNumber = date.getDate();
    const year = date.getFullYear();
    const formattedDate = `${month}/${dateNumber}/${year}`;
    return formattedDate;
  }

  const editBillData = async (fid) => {
    const data = await billService.getUserBills(id).then((bills) => {
      if (bills && bills.length) {
        return bills.filter((field) => {
          return field._id === fid;
        });
      }
    });
    data[0].purchaseItems = JSON.parse(data[0].purchaseItems);
    setBill(data[0]);
    // console.log(data[0]);
    setEditBill(true);
  };

  const openPayment = () => {
    return true;
  };

  const updateSetCheckBox = async (bid, status) => {
    setSubmitting(true);

    const data = await billService.getUserBills(id).then((bills) => {
      if (bills && bills.length) {
        return bills.filter((field) => {
          return field._id === bid;
        });
      }
    });

    data[0].purchaseItems = JSON.parse(data[0].purchaseItems);
    setBill(data[0]);

    let billSummary = {};
    billSummary.purchaseItems = [
      {
        price_data: {
          currency: data[0].purchaseItems[0].price_data.currency,
          unit_amount:
            data[0].purchaseItems[0].price_data.unit_amount.toString(),
          product_data: {
            name: data[0].purchaseItems[0].price_data.product_data.name,
            description:
              data[0].purchaseItems[0].price_data.product_data.description,
          },
        },
        quantity: 1,
      },
    ];
    billSummary.customer_email = user.email;
    billSummary.success_url = config.CURRENT_UI;
    billSummary.cancel_url = config.CURRENT_UI;
    billSummary.userId = user.id;
    billSummary.appName = "Signage-CMS";
    billSummary.stripeCustomer = "";
    billSummary.payType = "onetime";
    billSummary.payStatus = status;
    billSummary.invoicePath = "";
    billSummary.receiptPath = "";

    billService
      .updateBill(bid, billSummary)
      .then((data) => {
        // console.log(data);
        toast.success("Bill Updated Successfully", {
          keepAfterRouteChange: true,
        });
        setSubmitting(false); // submit animation stoped
        setEditBill(false); // Edit form is closing
        // history.push('.');
      })
      .catch((error) => {
        setSubmitting(false);
        toast.error(error);
      });
  };

  let userDetails = user;
  const UserDetails = ({ title, value, customValue, editButton, className }) => {
    // Initialize field value based on title
    const [field, setField] = useState(value || "");
    const [editfield, setEditField] = useState(false);

    // Update field when value changes
    useEffect(() => {
      setField(value || "");
    }, [value]);

    const handleUpdate = async (e) => {
      e.preventDefault();
      setSubmitting(true);

      const changedField = { [title]: field };

      try {
        await accountService.patch(user.id, changedField);
        // Update the parent component's user state to reflect changes immediately
        setUser((prevUser) => ({ ...prevUser, [title]: field }));
        setEditField(false);
        setSubmitting(false);
      } catch (error) {
        console.error("Failed to update user details", error);
        setSubmitting(false);
      }
    };

    // Function to get display value for non-edit mode
    const getDisplayValue = () => {
      if ((title === "plan" || title === "subscription") && field && plans.length > 0) {
        // Find the plan name based on the plan ID stored in field
        return getPlanNameById(customValue);
      }
      return field;
    };

    const handleEditClick = () => {
      if (title === "subscription" && loggedInUser && loggedInUser.role === "SUPER-ADMIN") {
        // For subscription field, use the manage functionality instead of edit
        setModalOpen(true);
        setModalTitle("Assign Subscription");
        setModalComponent(
          <ManageSubscription
            user={user}
            loggedInUser={loggedInUser}
            plans={plans}
            subs={subscriptions}
            closeModal={() => setModalOpen(false)}
            onUpdate={(planId, validUntil) => {
              if (planId && loggedInUser && loggedInUser.role.toUpperCase() == "SUPER-ADMIN") {
                accountService.patch(user.id, { planId, validUntil: validUntil })
                  .then(() => {
                    setUser(prev => ({ ...prev, planId, validUntil }));
                    setModalOpen(false);
                    toast.success("Subscription updated successfully");
                  })
                  .catch(error => toast.error(error));
              } else {
                setModalOpen(false);
              }
            }}
          />
        );
      } else {
        // For other fields, use the regular edit functionality
        setEditField(!editfield);
      }
    };

    const renderFormControl = () => {
      if (title === "currency") {
        return (
          <select
            className="modern-form-select"
            value={field}
            onChange={(e) => setField(e.target.value)}
          >
            <option value="AED">AED</option>
            <option value="ARS">ARS</option>
            <option value="AUD">AUD</option>
            <option value="BHD">BHD</option>
            <option value="BRL">BRL</option>
            <option value="CAD">CAD</option>
            <option value="CHF">CHF</option>
            <option value="CNY">CNY</option>
            <option value="DOP">DOP</option>
            <option value="EGP">EGP</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
            <option value="HKD">HKD</option>
            <option value="IDR">IDR</option>
            <option value="INR">INR</option>
            <option value="JMD">JMD</option>
            <option value="JPY">JPY</option>
            <option value="KES">KES</option>
            <option value="KWD">KWD</option>
            <option value="MXN">MXN</option>
            <option value="MYR">MYR</option>
            <option value="NGN">NGN</option>
            <option value="NZD">NZD</option>
            <option value="OMR">OMR</option>
            <option value="PHP">PHP</option>
            <option value="QAR">QAR</option>
            <option value="SAR">SAR</option>
            <option value="SGD">SGD</option>
            <option value="THB">THB</option>
            <option value="USD">USD</option>
            <option value="VND">VND</option>
            <option value="ZAR">ZAR</option>
          </select>
        );
      } else if (title === "role") {
        return (
          <select
            className="modern-form-select"
            value={field}
            onChange={(e) => setField(e.target.value)}
          >
            <option value="ADMIN">ADMIN</option>
            <option value="FRANCHISE-ADMIN">FRANCHISE ADMIN</option>
            <option value="MULTIVENDOR-ADMIN">MULTIVENDOR ADMIN</option>
            <option value="RESELLER">RESELLER</option>
            <option value="SUPER-ADMIN">SUPER ADMIN</option>

          </select>
        );
      } else if (title === "status") {
        return (
          <select
            className="modern-form-select"
            value={field}
            onChange={(e) => setField(e.target.value)}
          >
            <option value="active">ACTIVE</option>
            <option value="deactive">DEACTIVE</option>
          </select>
        );
      } else {
        return (
          <input
            type="text"
            value={field}
            className="modern-form-input"
            onChange={(e) => setField(e.target.value)}
            placeholder={`Enter ${title.replace(/([A-Z])/g, ' $1').toLowerCase()}`}
          />
        );
      }
    };

    const renderDisplayValue = () => {
      const displayValue = getDisplayValue();

      if (title === "status") {
        return (
          <span className={`status-indicator ${field}`}>
            {displayValue}
          </span>
        );
      }

      return (
        <span className={`detail-value ${!displayValue || displayValue === 'None' || displayValue === 'Not specified' ? 'empty' : ''}`}>
          {displayValue || 'Not specified'}
        </span>
      );
    };

    return (
      <div className={`detail-card ${editfield ? 'editing' : ''} ${title === 'subscription' ? 'subscription-card' : ''} ${title === 'status' ? 'status-card' : ''} ${className || ''}`}>
        <label className="detail-label">
          {title.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
        </label>

        {!editfield ? (
          <div className="detail-row">
            {renderDisplayValue()}
            <div className="detail-actions">
              <button
                className="edit-action-btn"
                onClick={handleEditClick}
                disabled={isSubmitting}
                title={title === "subscription" && loggedInUser && loggedInUser.role === "SUPER-ADMIN" ? "Manage" : "Edit"}
              >
                <i className="bi bi-pencil-square"></i>
              </button>
            </div>
          </div>
        ) : (
          <form className="detail-edit-form" onSubmit={handleUpdate}>
            <div className="input-button-container">
              <div className="input-wrapper">
                {renderFormControl()}
              </div>
              <div className="form-action-buttons">
                <button
                  type="submit"
                  className="form-action-btn save-btn"
                  disabled={isSubmitting}
                  title="Save changes"
                >
                  {isSubmitting ? (
                    <div className="loading-dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  ) : (
                    <i className="bi bi-check-lg"></i>
                  )}
                </button>
                <button
                  type="button"
                  className="form-action-btn cancel-btn"
                  onClick={() => setEditField(false)}
                  title="Cancel editing"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    );
  };

  return (
    <div className={"user-details"} style={{ padding: "20px" }}>

      <div className="d-md-flex justify-content-between align-items-center">
        {loggedInUser && loggedInUser.role === "SUPER-ADMIN" && (
          <Link to={".."} className="back-btn">
            <i className="bi bi-arrow-left"></i>
          </Link>
        )}
        <h3>{` ${user ? user.firstName + " " + user.lastName : ""}`}</h3>

        {loggedInUser && loggedInUser.role === "SUPER-ADMIN" &&
          <span className="status-chip status-badge active">
            {user && user.status && user.status.toUpperCase()}
          </span>
        }

        {showConfirm && (
          <div className="dialog-overlay">
            <div className="dialog">
              <h3>Are you sure?</h3>
              <p>
                Are you sure you want to{" "}
                {isDeactivated ? "activate" : "deactivate"} the account?
              </p>
              <div>
                <button className="confirm" onClick={handleConfirm}>Yes</button>
                <button className="cancel" onClick={() => setShowConfirm(false)}>No</button>
              </div>
            </div>
          </div>
        )}
      </div>
      {user && (
        <div className="personal-details-wrapper">
          <div >
            <div className="personal-details-header">
              <h4 className="personal-details-title">
                Personal Details
              </h4>
              <button
                onClick={() => {
                  setModalOpen(true);
                  setModalTitle("Reset Password");

                  setModalComponent(
                    <ResetPassword
                      closeModal={() => setModalOpen(false)}
                      user={user}
                    />
                  );
                }}
                className="reset-password-btn"
              >
                <i className="bi bi-shield-lock"></i>
                Reset Password
              </button>
            </div>
            <div className="personal-details-content">
              <div className="details-grid">
                <UserDetails title="firstName" value={user.firstName} />
                <UserDetails title="lastName" value={user.lastName} />
                <UserDetails title="email" value={user.email} />
                <UserDetails title="phone" value={user.phone} />
                <UserDetails title="address" value={user.address} />
                <UserDetails title="currency" value={user.currency} />
                <UserDetails
                  title="paymentProviderCode"
                  value={user.paymentProviderCode}
                />
                <UserDetails
                  title="paymentProviderType"
                  value={user.paymentProviderType}
                />


                <UserDetails title="taxPerc" value={user.taxPerc} />

                {false && loggedInUser && loggedInUser.role === "SUPER-ADMIN" && (
                  <UserDetails title="status" value={user.status} />
                )}


                {loggedInUser && loggedInUser.role === "SUPER-ADMIN" ? (
                  <UserDetails
                    title="subscription"
                    value={user.planId}
                    customValue={
                      user.planId
                    }
                  />
                ) : <div><label style={{ color: "#2d2b2b", fontWeight: "bold" }}>SUBSCRIPTION </label><br /><span>{getSubsPlanById(user.planId)}</span></div>}
                <div><label style={{ color: "#2d2b2b", fontWeight: "bold" }}>VALID UNTIL </label><br /><span style={{ color: "#777" }}>{user.validUntil}</span></div>
                {loggedInUser && loggedInUser.role === "SUPER-ADMIN" && (
                  <UserDetails title="role" value={user.role} />
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {user && !user.isIAM && (
        <div className="user-detail-section">
          <div>
            <Roles
              modalState={modalOpen}
              user={user}
              showModal={(status) => setModalOpen(status)}
              showModalContent={(c, title) => {
                setModalOpen(true);
                setModalTitle(title);
                setModalComponent(c);
              }}
            />
          </div>
        </div>
      )}

      {/* Display Franchise component for FRANCHISE-ADMIN users */}
      {loggedInUser &&
        (loggedInUser.role != "ADMIN") && (user && (user.role.toUpperCase() === "FRANCHISE-ADMIN")) && (
          <div className="user-detail-section">
            <div>
              <Franchise
                user={user}
                modalState={modalOpen}
                showModal={(status) => setModalOpen(status)}
                showModalContent={(c, title) => {
                  setModalOpen(true),
                    setModalTitle(title),
                    setModalComponent(c);
                }}
              />
            </div>
          </div>
        )}

      {/* Display MultiVendor component for MULTIVENDOR-ADMIN users */}
      {loggedInUser &&
        (loggedInUser.role != "ADMIN") && (user && (user.role.toUpperCase() === "MULTIVENDOR-ADMIN")) && (
          <div className="user-detail-section">
            <div>
              <MultiVendor
                user={user}
                modalState={modalOpen}
                showModal={(status) => setModalOpen(status)}
                showModalContent={(c, title) => {
                  setModalOpen(true),
                    setModalTitle(title),
                    setModalComponent(c);
                }}
              />
            </div>
          </div>
        )}

      {user && !user.isIAM && (
        <div className="user-detail-section">
          <div>
            <Members
              modalState={modalOpen}
              user={user}
              showModal={(status) => {
                setModalOpen(status);
                if (!status) {
                  setModalComponent(null);
                  setModalTitle("");
                }
              }}
              showModalContent={(c, title, onClose) => {
                setModalOpen(true);
                setModalTitle(title);
                setModalComponent(c);
                // Store the close callback for later use
                if (onClose) {
                  setModalComponent(React.cloneElement(c, {
                    ...c.props,
                    onModalClose: onClose
                  }));
                }
              }}
            />
          </div>
        </div>
      )}

      {user && !(user.role === "member" || MemberIdCheck(user.role)) && (
        <div className="user-detail-section">
          <div className="personal-details-header">
            <h4>Bill Details</h4>
            {loggedInUser && loggedInUser.role === "SUPER-ADMIN" && (
              <button
                onClick={() => setCreateBill(true)}
                className="border-only-btn"
              >
                <i class="bi bi-plus-square" style={{ marginRight: "6px" }}></i>
                Generate New Bill
              </button>
            )}
          </div>
          {user && (
            <div id="bill_All_Details" style={{ marginTop: "20px" }}>
              {billData && billData.length ? <table className="table table-striped">
                <thead>
                  <tr>
                    <th style={{ width: "30%" }}>Due Date</th>
                    <th style={{ width: "30%" }}>Status</th>
                    <th style={{ width: "20%" }}>Amount</th>
                    {user && user.role === "SUPER-ADMIN" && (
                      <th style={{ width: "10%" }}>Mark Paid</th>
                    )}
                    <th style={{ width: "10%" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {billData &&
                    billData.map((user) => (
                      <tr key={user._id}>
                        <td>{convertDateFormate(user.createdAt)}</td>
                        <td
                          style={{ textTransform: "uppercase" }}
                          className={`mt-2 badge badge-pill align-items-center ${user.payStatus === "paid"
                            ? "badge-success"
                            : "badge-warning"
                            } statusButton`}
                        >
                          {user.payStatus}
                        </td>
                        <td>
                          <Currency
                            quantity={
                              user && user.purchaseItems
                                ? user.purchaseItems &&
                                JSON.parse(user.purchaseItems)[0].price_data
                                  .unit_amount / 100
                                : 0
                            }
                            currency={
                              user && user.purchaseItems
                                ? user.purchaseItems &&
                                JSON.parse(user.purchaseItems)[0].price_data
                                  .currency
                                : "INR"
                            }
                          />
                        </td>
                        {role &&
                          role.user &&
                          role.user.role === "SUPER-ADMIN" && (
                            <td>
                              <input
                                type="checkbox"
                                className={"checkbox-common"}
                                name=""
                                id=""
                                checked={user.payStatus === "paid"}
                                onChange={() =>
                                  updateSetCheckBox(
                                    user._id,
                                    user.payStatus === "paid"
                                      ? "unpaid"
                                      : "paid"
                                  )
                                }
                              />
                            </td>
                          )}
                        {role &&
                          role.user &&
                          role.user.role === "SUPER-ADMIN" ? (
                          <td style={{ whiteSpace: "nowrap" }}>
                            <button
                              onClick={() => {
                                editBillData(user._id);
                              }}
                              className="btn btn-sm btn-primary mr-1"
                            >
                              Edit
                            </button>
                          </td>
                        ) : (
                          <td style={{ whiteSpace: "nowrap" }}>
                            <button
                              onClick={() => {
                                openPayment(user._id);
                              }}
                              className="btn btn-sm btn-primary mr-1"
                            >
                              Pay Now
                            </button>
                          </td>
                        )}
                        <td>
                          <button
                            className="text-primary border-only-btn"
                            onClick={() => {
                              setShowPopup(true);
                              setInvoiceTitle("Invoice");
                              setInvoiceComponent(
                                <Invoice
                                  user={user}
                                  userDetails={userDetails}
                                  loggedInUser={loggedInUser}
                                />
                              );
                            }}
                          >
                            Invoice
                          </button>
                        </td>
                      </tr>
                    ))}
                  {!user && (
                    <tr>
                      <td colSpan="4" className="text-center">
                        <span className="spinner-border spinner-border-lg align-center"></span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table> : <span style={{ textAlign: "center", width: "100%", display: "inline-block" }}>No Bill found</span>}
            </div>
          )}
        </div>
      )}

      {/* Opening invoice */}

      {/* Closing invoice */}

      {/* Edit Bill Start */}

      {editBill &&
        user &&
        !(user.role === "member" || MemberIdCheck(user.role)) && (
          <div id="bill_summary">
            <div
              className="Form_blur_background"
              onClick={() => setEditBill(false)}
            ></div>
            <div className="modal-content">
              <h4>Billing Details</h4>

              {/* Title */}
              <div>
                <label htmlFor="title">Title For Product/Service</label>
                <input
                  id="title"
                  className="modal-input"
                  onChange={(e) => updateBillProduct(e, "name")}
                  type="text"
                  defaultValue={
                    bill
                      ? bill.purchaseItems[0].price_data.product_data.name
                      : ""
                  }
                />
              </div>

              {/* Description */}
              <div>
                <label htmlFor="billText">
                  Description For Product/Service
                </label>
                <textarea
                  id="billText"
                  className="modal-textarea"
                  defaultValue={
                    bill
                      ? bill.purchaseItems[0].price_data.product_data
                        .description
                      : ""
                  }
                  onChange={(e) => updateBillProduct(e, "description")}
                  placeholder="Enter User Package details here..."
                ></textarea>
              </div>

              {/* Currency and Payment Status */}
              <div>
                <label htmlFor="curr-select">Select Currency</label>
                <select
                  id="curr-select"
                  className="modal-select"
                  onChange={(e) => updateBillPrice(e, "currency")}
                  selected={
                    bill &&
                    bill.purchaseItems[0].price_data.currency
                  }
                >
                  <option value="BHD">BHD</option>
                  <option value="CAD">CAD</option>
                  <option value="CHF">CHF</option>
                  <option value="DOP">DOP</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                  <option value="INR">INR</option>
                  <option value="JMD">JMD</option>
                  <option value="OMR">OMR</option>
                  <option value="USD">USD</option>
                  <option value="VND">VND</option>
                </select>
              </div>

              <div>
                <label htmlFor="payStatus">Pay Status</label>
                <select
                  id="payStatus"
                  className="modal-select"
                  onChange={(e) => updateBillPayStatus(e, "payStatus")}
                >
                  <option
                    value="paid"
                    selected={bill && bill.payStatus === "paid"}
                  >
                    Paid
                  </option>
                  <option
                    value="unpaid"
                    selected={bill && bill.payStatus === "unpaid"}
                  >
                    Unpaid
                  </option>
                </select>
              </div>

              <div>
                <label htmlFor="amount">Amount to pay (In cents)</label>
                <input
                  id="amount"
                  className="modal-input"
                  type="number"
                  defaultValue={
                    bill
                      ? parseInt(bill.purchaseItems[0].price_data.unit_amount)
                      : 0
                  }
                  onChange={(e) => updateBillPrice(e, "unit_amount")}
                />
              </div>

              {/* Save and Close Buttons */}
              <div className="button-container">
                <button
                  onClick={() => setEditBill(false)}
                  className="btn btn-danger"
                >
                  Close
                </button>

                <button
                  onClick={() => onBillingInfoUpdate(bill._id)}
                  disabled={isSubmitting}
                  className="btn btn-primary"
                >
                  {isSubmitting && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                  )}
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Edit Bill End */}

      {/* Create Bill Start */}
      {createBill &&
        user &&
        !(user.role === "member" || MemberIdCheck(user.role)) && (
          <div id="bill_summary" className="create-bill-container">
            <div
              className="create-bill-overlay"
              onClick={() => setCreateBill(false)}
            ></div>

            <div className="create-bill-box">
              <h4 className="create-bill-title">Billing Details</h4>

              <div className="form-group">
                <label htmlFor="title" className="form-label">
                  Title For Product/Service
                </label>
                <input
                  id="title"
                  className="form-input"
                  onChange={(e) => createBillProduct(e, "name")}
                  type="text"
                  defaultValue={
                    createBillData
                      ? createBillData.purchaseItems[0].price_data.product_data
                        .name
                      : ""
                  }
                />
              </div>

              {/* Description */}
              <div className="form-group">
                <label htmlFor="billText" className="form-label">
                  Description For Product/Service
                </label>
                <textarea
                  id="billText"
                  className="form-textarea"
                  defaultValue={
                    createBillData
                      ? createBillData.purchaseItems[0].price_data.product_data
                        .description
                      : ""
                  }
                  onChange={(e) => createBillProduct(e, "description")}
                  placeholder="Enter User Package details here..."
                ></textarea>
              </div>

              {/* Currency */}
              <div className="form-group">
                <label htmlFor="curr-select" className="form-label">
                  Select Currency
                </label>
                <select
                  id="curr-select"
                  className="form-select"
                  onChange={(e) => createBillPrice(e, "currency")}
                  selected={
                    createBillData &&
                    createBillData.purchaseItems[0].price_data.currency}
                >
                  <option value="BHD">BHD</option>
                  <option value="CAD">CAD</option>
                  <option value="CHF">CHF</option>
                  <option value="DOP">DOP</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                  <option value="INR">INR</option>
                  <option value="JMD">JMD</option>
                  <option value="OMR">OMR</option>
                  <option value="USD">USD</option>
                  <option value="VND">VND</option>
                </select>
              </div>

              {/* Pay Status */}
              <div className="form-group">
                <label htmlFor="pay-status" className="form-label">
                  Pay Status
                </label>
                <select
                  id="pay-status"
                  className="form-select"
                  onChange={(e) => createBillPayStatus(e, "payStatus")}
                >
                  <option
                    selected={
                      createBillData && createBillData.payStatus == "paid"
                    }
                    value="paid"
                  >
                    Paid
                  </option>
                  <option
                    selected={
                      createBillData && createBillData.payStatus == "unpaid"
                    }
                    value="unpaid"
                  >
                    Unpaid
                  </option>
                </select>
              </div>

              {/* Amount */}
              <div className="form-group">
                <label htmlFor="amount" className="form-label">
                  Amount to pay (In cent)
                </label>
                <input
                  id="amount"
                  className="form-input"
                  type="number"
                  defaultValue={
                    createBillData
                      ? parseInt(
                        createBillData.purchaseItems[0].price_data.unit_amount
                      )
                      : 0
                  }
                  onChange={(e) => createBillPrice(e, "unit_amount")}
                />
              </div>

              {/* Buttons */}
              <div className="form-actions">
                <button
                  onClick={() => setCreateBill(false)}
                  className="btn btn-danger"
                >
                  Close
                </button>
                <button
                  onClick={() => onCreateBill()}
                  disabled={isSubmitting}
                  className="btn btn-primary"
                >
                  {isSubmitting && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  Create
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Create Bill End */}

      <div
        className="modal-popup"
        style={{ display: modalOpen ? "block" : "none" }}
        onClick={(e) => {
          // Only close when clicking the backdrop (not when clicking inside the modal)
          if (e.target === e.currentTarget) {
            console.log("Backdrop clicked - closing modal");
            setModalOpen(false);
          }
        }}
      >
        {modalTitle ? (
          // Traditional modal with header
          <div className={`modal modal-responsive ${modalTitle === 'Role Permissions' ? 'permissions-modal' : ''}`}>
            <article className="modal-container">
              <header className="modal-container-header">
                <h3 className="modal-container-title">{modalTitle}</h3>
                <button
                  className="icon-button"
                  onClick={(e) => {
                    // Fallback: close the modal directly
                    setModalOpen(false);
                    setModalComponent(null);
                    setModalTitle("");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      fill="currentColor"
                      d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
                    />
                  </svg>
                </button>
              </header>
              <section className={`modal-container-body rtf ${modalTitle === 'Role Permissions' ? 'permissions-body permissions-body-responsive' : ''}`}>
                {modalComponent}
              </section>
              <footer
                style={{ display: "none" }}
                className="modal-container-footer"
              >
                <button className="button is-ghost">Decline</button>
                <button className="button is-primary">Accept</button>
              </footer>
            </article>
          </div>
        ) : (
          // Direct render of AddRolePermissionPopup which has its own modal handling
          <div className="role-permission-popup-wrapper">
            {modalComponent}
          </div>
        )}
      </div>

      <div
        className="modal-popup"
        style={{ display: showPopup ? "block" : "none" }}
      >
        <div className="modal modal-responsive">
          <article className="invoiceModelContainer">
            <header className="modal-container-header">
              <h3 className="modal-container-title">{invoiceTitle}</h3>
              <button
                className="icon-button"
                onClick={() => setShowPopup(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    fill="currentColor"
                    d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
                  />
                </svg>
              </button>
            </header>
            <section className="modal-container-body rtf">
              {invoiceComponent}
            </section>
            <footer
              style={{ display: "none" }}
              className="modal-container-footer"
            >
              <button className="button is-ghost">Decline</button>
              <button className="button is-primary">Accept</button>
            </footer>
          </article>
        </div>
      </div>
      {/* Show delete button only if logged-in user has higher privilege than viewed user */}
      {loggedInUser && user && (
        (loggedInUser.role === "SUPER-ADMIN" && user.role !== "SUPER-ADMIN") ||
        ((loggedInUser.role === "FRANCHISE-ADMIN" || loggedInUser.role === "MULTIVENDOR-ADMIN") && user.role !== "SUPER-ADMIN" && user.role !== "FRANCHISE-ADMIN" && user.role !== "MULTIVENDOR-ADMIN") ||
        (loggedInUser.role === "ADMIN" && (user.role === "member" || MemberIdCheck(user.role)))
      ) && (
          <div className="delete-btn-container">
            <button className="delete-btn" style={{ background: "#fff", border: "1px solid red", color: "red" }} onClick={() => setShowDeleteDialog(true)}>
              Delete Account
            </button>
            <button
              className={` ${isDeactivated ? "activate-btn" : "deactivate-btn"
                }`}
              onClick={() => setShowConfirm(true)
              }
              style={{ marginLeft: "20px", border: "none", borderRadius: "5px", padding: "10px" }}
            >
              {isDeactivated ? "Activate Account" : "Deactivate Account"}
            </button>
          </div>
        )}

      {/* Delete confirmation dialog */}
      {showDeleteDialog && (
        <div className="dialog-overlay">
          <div className="dialog">
            <h3>Warning!!</h3>
            <p>
              Are you sure you want to delete user{" "}
              <strong>
                "{user.firstName} {user.lastName}"
              </strong>
              ?
            </p>
            <div>
              <button className="confirm" onClick={handleDelete}>Yes</button>
              <button className="cancel" onClick={() => setShowDeleteDialog(false)}>No</button>
            </div>
          </div>
        </div>
      )}

      {/* Expiry Popup */}
      {showExpiryPopup && user && loggedInUser && (
        <ExpiryPopup
          user={user}
          plans={plans}
          subscriptions={subscriptions}
          onClose={handleExpiryClose}
          onExtend={handleExpiryExtend}
        />
      )}
    </div>
  );
}

export { View };
